import {
  QuestionType,
  QuestionTypes,
} from "../pages/GamePage/constants/QuestionTypes";
import { QuizQuestion } from "../pages/GamePage/types/QuizQuestion";
import { shuffleArray } from "./shuffleArray";
import * as ItemsApi from "../network/items_api";

export const generateQuizQuestions = async (gameSetId: string) => {
  const level: QuizQuestion[] = [];
  const items = await ItemsApi.fetchItems(gameSetId);
  const WRONG_ANSWERS_LENGTH = 3;
  const NB_STAGES = items.length;

  // Shuffle the items array to randomize question order.
  const shuffledItems = shuffleArray([...items]);

  let currentQuestionNumber = 0;

  // Loop through the shuffled items and create questions.
  while (currentQuestionNumber < NB_STAGES) {
    const item = shuffledItems[currentQuestionNumber];

    // Initialize questionType with SHORT_ANSWER by default
    let questionType: QuestionType = QuestionTypes.SHORT_ANSWER;

    // To get multiple choice questions make sure to have at least 5 items
    if (NB_STAGES >= 5) {
      questionType =
        Math.random() > 0.5
          ? QuestionTypes.MULTIPLE_CHOICE
          : QuestionTypes.SHORT_ANSWER;
    }

    let quizItem: QuizQuestion;

    if (questionType === QuestionTypes.MULTIPLE_CHOICE) {
      // Generate incorrect answers and shuffle them
      const wrongAnswers = shuffledItems
        .filter((element) => element.solution !== item.solution)
        .slice(0, WRONG_ANSWERS_LENGTH)
        .map((element) => element.solution);

      const answers = shuffleArray([...wrongAnswers, item.solution]);

      quizItem = {
        question: item.question,
        solution: item.solution,
        options: answers,
        type: QuestionTypes.MULTIPLE_CHOICE,
      };
    } else {
      quizItem = {
        question: item.question,
        solution: item.solution,
        type: QuestionTypes.SHORT_ANSWER,
      };
    }

    level.push(quizItem);
    currentQuestionNumber++;
  }

  return level;
};
